import { render, staticRenderFns } from "./RecontactHives.vue?vue&type=template&id=c5bceeb6&lang=pug&"
import script from "./RecontactHives.vue?vue&type=script&lang=js&"
export * from "./RecontactHives.vue?vue&type=script&lang=js&"
import style0 from "./RecontactHives.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports